import type { Tagged } from 'type-fest';

export type _SessionIdentifier = {
  type: _SessionIdentifier.Type;
  value: string;
};

export namespace _SessionIdentifier {
  export type Type = Tagged<string, 'SessionIdentifierType'>;
  export namespace Type {
    const Pattern = /^[a-zA-Z0-9_]+$/;
    export const FromString = (s: string): Type => {
      if (!Pattern.test(s)) {
        throw new Error(`Invalid SessionIdentifier.Type: ${JSON.stringify(s)} (allowed: [a-zA-Z0-9_]+)`);
      }
      return s as Type;
    };
  }

  export type Props = {
    type: string;
    value: string;
  };
  export const Construct = (props: Props): _SessionIdentifier => {
    return {
      type: Type.FromString(props.type),
      value: props.value,
    };
  };

  export const ToString = (identifier: _SessionIdentifier): string => {
    return `${identifier.type}:${identifier.value}`;
  };
}
